const _ = require("lodash");
const toId = require("to-id");
import { Geolocatable, haversineDistance } from "@/models/Geolocation";
import { Shop } from "@/models/Shop";

const OverpassApiServiceFactory = (fetch: Function) => {
  return class OverpassApiService {
    async getCloseShops(position: Geolocatable) {
      const response = await fetch(
        "https://z.overpass-api.de/api/interpreter",
        {
          method: "POST",
          body: `[out:json];

      (
        node[shop](around:50.0,${position.latitude},${position.longitude});
        node[amenity=marketplace](around:50.0,${position.latitude},${position.longitude});
      );

      out tags center qt;
      `,
          mode: "cors",
        }
      );

      const data = await response.json();

      const relevantElements = data.elements.filter(
        (element: any) => element.tags.name
      );

      const elementsSortedByDistance = _.sortBy(
        relevantElements,
        (element: { lat: number; lon: number }) => {
          return haversineDistance(position, {
            latitude: element.lat,
            longitude: element.lon,
          });
        }
      );

      return elementsSortedByDistance.map(
        (element: any) =>
          new Shop({
            _id: `Shop:${toId(element.tags.name)}-osm-${element.id}`,
            name: element.tags.name,
            position: {
              latitude: element.lat,
              longitude: element.lon,
            },
          })
      );
    }
  };
};

export { OverpassApiServiceFactory };
